import { render, staticRenderFns } from "./MenuCv.vue?vue&type=template&id=3af1a83c"
import script from "./MenuCv.vue?vue&type=script&lang=js"
export * from "./MenuCv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports